/**
 * Feature flags — chaves simples pra esconder/exibir features sem deploy
 * complexo. Vire pra `true` quando o conteúdo estiver pronto.
 */

/**
 * Quando false:
 *  - Card "Mindfulness" some da BibliotecaCardsGrid, SugestaoBlock e QuickMenu.
 *  - Item "Mindfulness" some do ParaAgoraBlock (dentro do Ritual).
 *  - Itens com tipo "audio" são filtrados do catálogo da Biblioteca.
 *
 * Rota /biblioteca/mindfulness segue existindo (deep-links salvos não quebram),
 * mas nenhum ponto de entrada visível leva pra ela.
 */
export const AUDIOS_ENABLED = false;

/**
 * B2B_PUBLICO_ATIVO (14/10/2026) — páginas /empresas/* fora do ar por decisão
 * da Simone; só volta com autorização dela. Desligado: toda rota /empresas/*
 * redireciona para a home, sai do sitemap e vira casca noindex. O código das
 * páginas continua no projeto. Espelho na edge: chat-b2b-presale (B2B_PRESALE_ATIVO).
 */
export const B2B_PUBLICO_ATIVO = false;

/**
 * B2B_PAGINA_VISIVEL (02/11/2026) — abre SÓ a página /empresas (contato por
 * WhatsApp e formulário b2b-lead) e manda /empresas/demo e /empresas/* para
 * ela. Resgate, aceite, RH, campo de código e marca seguem presos a
 * B2B_PUBLICO_ATIVO. A página continua fora do sitemap e com noindex.
 */
export const B2B_PAGINA_VISIVEL = true;

/**
 * PAYWALL_MODAL_DIRECT_CHECKOUT (20/08/2026)
 * ------------------------------------------
 * ON  → PaywallModal compra ali mesmo (Stripe no web, folha da loja no nativo).
 * OFF → PaywallModal volta a navegar para /maternar/planos (comportamento antigo).
 *
 * A flag governa SÓ O DESTINO do toque. Os eventos de topo de funil
 * (`upsell_surface_clicked` / `paywall_cta_clicked`) são emitidos por
 * src/lib/paywallIntent.ts fora de qualquer flag — com a flag desligada o
 * antes/depois continua comparável, que é o único motivo de existir rollback.
 *
 * NÃO espelhar em supabase/functions/_shared/contentFlags.ts: nenhuma edge
 * function precisa saber desta flag (não filtra conteúdo, não alimenta prompt
 * nem push). Espelhar sem consumidor é justamente o que já nos morde — flag
 * espelhada à mão só entra no contentFlags quando existir uma edge lendo ela,
 * e nesse dia o teste de paridade (src/test/copy/paridadeContentFlags.test.ts)
 * passa a cobri-la.
 */
export const PAYWALL_MODAL_DIRECT_CHECKOUT = true;

/**
 * Interruptores do B2B que nunca foi usado (29/10/2026). Canônico em
 * supabase/functions/_shared/b2bRecursos.ts — mesmo valor nas funções e nas telas.
 */
export {
  B2B_API_ATIVA, B2B_WEBHOOKS_ATIVOS, B2B_SSO_ATIVO, B2B_COMPRA_ATIVA,
  B2B_WHATSAPP_ATIVO, B2B_METRICAS_ATIVAS,
} from "../../supabase/functions/_shared/b2bRecursos";
